import { GoogleMap, CircleF, useJsApiLoader } from '@react-google-maps/api';
import { circleOptions, defaultCenter } from './static';
import { GMapsPlaceMarkerProps } from './types';


function GMapsPlaceCircle(props: GMapsPlaceMarkerProps) {
  const {
    height = '100%',
    location = undefined, 
    zoom = 7,
    center = (location?.lat && location?.lng)
      ? props.location
      : defaultCenter
  } = props;  
      
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
    // libraries: ['geometry', 'drawing'],
  });

  return (<>
    {isLoaded && <GoogleMap
      options={{
        draggable: false
      }}
      mapContainerStyle={{
        height: height,
        width: '100%'
      }}
      zoom={zoom}
      center={center}
    >
      {
        location 
          ? <CircleF
            center={location}
            options={circleOptions}
          />
          : null
      }
        
    </GoogleMap>
    }
  </>);
}

export default GMapsPlaceCircle;